module.exports = __webpack_public_path__ + "static/media/administracion.e6d7b6f9.svg";